import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IEmptyResult } from '~src/httpClient/serverApi/types/IResponse';

type UpdateLinkedTasksPriorityParams = {
  readonly ids: string[]; // LinkedTaskIds
  readonly priority: string;
}

export class UpdateLinkedTasksPriorityRequest extends Request<UpdateLinkedTasksPriorityParams, IEmptyResult> {
  constructor(params: UpdateLinkedTasksPriorityParams) {
    super('setLinkedTasksPriority', params);
  }
}
